export default "__VITE_ASSET__8m6mEuPz__"